import { createContext, useContext, useEffect, useState } from "react";
import {
  getCustToken, setCustToken, clearCustToken, customerMe, customerLogin, customerRegister,
} from "../lib/customerApi";

const Ctx = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!getCustToken()) { setUser(false); setReady(true); return; }
      try {
        const me = await customerMe();
        setUser(me);
      } catch { clearCustToken(); setUser(false); }
      finally { setReady(true); }
    };
    check();
  }, []);

  const login = async (email, password) => {
    const { token, user: u } = await customerLogin(email, password);
    setCustToken(token); setUser(u); return u;
  };
  const register = async (payload) => {
    const { token, user: u } = await customerRegister(payload);
    setCustToken(token); setUser(u); return u;
  };
  const logout = () => { clearCustToken(); setUser(false); };

  return (
    <Ctx.Provider value={{ user, ready, login, register, logout }}>
      {children}
    </Ctx.Provider>
  );
};

export const useCustomerAuth = () => useContext(Ctx);
